import React from 'react'
import styled from 'styled-components';

export const CaseRequestInfo = styled(({caseRequest, className}) => <div className={className}>
  {caseRequest.requestCode && <div><b>Expert request code:</b> {caseRequest.requestCode}</div>}
  <div><b>Patient name:</b> {caseRequest.patientInfo.firstName} {caseRequest.patientInfo.lastName}</div>
</div>)`
`
